import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "next-themes";
import "@/index.css";
import App from "@/App";
import { initNativeShell } from "@/native/capacitorShell";

initNativeShell();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false} storageKey="numuv-theme-v2">
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
